"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TransactionRequest = /** @class */ (function () {
    function TransactionRequest() {
    }
    return TransactionRequest;
}());
exports.TransactionRequest = TransactionRequest;
//# sourceMappingURL=TransactionRequest.js.map